import axios from 'axios';

const baseApiPrefix= "/hcmdev";
const apiKey= "apiberca2021";


export default class OpusBRequest {

    private header: any = {
        'apikey' : apiKey,
        'Content-Type': 'application/json'
    }

    public getHeader(): any{

        const token= localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');

        const header= this.header;

        if(typeof(this.header.Authorization) == undefined && !!token){
            this.applyAppToken(token);
        }
        return this.header;
    }

    public applyAppToken(token: string): OpusBRequest {
        this.addHeader({"Authorization" : `Bearer ${token}`});
        return this;
    }

    public addHeader(newHeader: any): OpusBRequest {
        this.header= Object.assign(this.header, newHeader);

        return this;
    }

    public async post(url:string, data:object): Promise<any> {
        return this.doRequest(url, "POST", data);
    }

    public async get(url:string, data: object): Promise<any> {
        return this.doRequest(url, "GET", data);
    }

    public async put(url: string, data: object): Promise<any> {
        return this.doRequest(url, "PUT", data);
    }

    public async patch(url: string, data: object): Promise<any> {
        return this.doRequest(url, "PATCH", data);
    }

    public async doRequest(url:string, method:string, data: object):Promise<any> {
        return new Promise<any>((resolve, reject)=> {
            const config: any= {
                url : `${baseApiPrefix}/${url}`,
                method : method,
                headers : this.getHeader(),
                data: JSON.stringify(data)
            }

            axios(config)
            .then(res=> {
                resolve(res.data);
            }).catch(e=> {
                console.log({e});
                reject();
            })
        });
    }
}